import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import Breadcrumb from '../../components/Breadcrumb';
import RightArrow from '../../components/SVG';
import SectionTitle from '../../components/SectionTitle';
import SingleTeamThree from '../../components/Team/SingleTeamThree';
import NextArrow from '../../components/SVG/NextArrow';
import PrevArrow from '../../components/SVG/PrevArrow';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';
import { useSiteSettings } from '../../lib/api/settings';
import { personPhoto } from '../../data/images';

const TeacherDetailsMain = () => {
  const { contact } = useSiteSettings();
  const content = useCollections('staff', 'chairman');
  if (content.loading || content.error) return <DataState state={content} />;
  const { staff, chairman } = content;
  const lecturers = staff.filter((s) => /Professor|Senior Lecturer/.test(s.rank)).slice(0, 8);
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '4',
    spaceBetween: 50,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      1400: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };
  return (
    <main>
      <Breadcrumb title="Chairman" subTitle="Leadership" />

      <div className="it-teacher-details-area pt-120 pb-120">
        <div className="container">
          <div className="it-teacher-details-wrap">
            <div className="row">
              <div className="col-xl-3 col-lg-3">
                <div className="it-teacher-details-left">
                  <div className="it-teacher-details-left-thumb">
                    <img src={personPhoto(chairman)} alt="" />
                  </div>
                  <div className="it-teacher-details-left-info">
                    <ul>
                      <li>
                        <i className="fa-light fa-phone-volume"></i>
                        <a href={contact.generalPhoneHref}>
                          {contact.generalPhone}
                        </a>
                      </li>
                      <li>
                        <i className="fa-light fa-location-dot"></i>
                        <a
                          href="https://www.google.com/maps/search/SANASA+Campus+Paragammana+Kegalle"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Paragammana, Kegalle
                        </a>
                      </li>
                      <li>
                        <i className="fa-light fa-envelope"></i>
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                      </li>
                    </ul>
                  </div>
                  <div className="it-teacher-details-left-btn">
                    <Link className="ed-btn-theme" to="/contact">
                      <span>
                        Contact Us
                        <i>
                          <RightArrow />
                        </i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-9 col-lg-9">
                <div className="it-teacher-details-right">
                  <div className="it-teacher-details-right-title-box">
                    <h4>{chairman ? chairman.name : 'Dr. P. A. Kiriwandeniya'}</h4>
                    <span>{chairman ? chairman.title : 'Chairman and Managing Director'}</span>
                    <p>
                      Dr. P. A. Kiriwandeniya is the founder, Chairman and
                      Managing Director of SANASA Campus Ltd. The campus grew
                      out of the SANASA co-operative movement.
                    </p>
                    <p>
                      The campus received degree-awarding status from the
                      Ministry of Higher Education in January 2014.
                    </p>
                  </div>
                  <div className="it-teacher-details-right-content mb-40">
                    <h4>Chairman's Message</h4>
                    {chairman && chairman.message
                      ? chairman.message.split(/\n\s*\n/).map((para) => <p key={para}>{para}</p>)
                      : null}
                  </div>
                  <div className="it-teacher-details-right-content">
                    <h4>Key Dates</h4>
                    <p>
                      1978: the SANASA movement began. 2003: SANASA Campus Ltd.
                      was formed. 2014: the campus received degree-awarding
                      status.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ed-team-area grey-bg-5 p-relative inner-style fix z-index pt-110 pb-120">
        <div className="container">
          <div className="it-team-title-wrap mb-40">
            <div className="row align-items-center justify-content-center">
              <div className="col-xl-6">
                <SectionTitle
                  itemClass="it-team-title-box text-center"
                  subTitleClass="ed-section-subtitle"
                  subTitle="Our Team"
                  titleClass="ed-section-title"
                  title="Meet Our Lecturers"
                />
              </div>
            </div>
          </div>
          <div className="ed-team-wrapper">
            <div className="swiper-container ed-team-active">
              <Swiper
                modules={[Autoplay, Navigation]}
                {...sliderOption}
                className="swiper-wrapper"
              >
                {lecturers.map((p) => (
                  <SwiperSlide key={p.fullName} className="swiper-slide">
                    <SingleTeamThree
                      teamImage={personPhoto(p)}
                      authorName={p.displayName}
                      designation={p.rank}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="ed-team-arrow-box mt-65 text-center">
                <button className="slider-prev">
                  <PrevArrow />
                </button>
                <button className="slider-next">
                  <NextArrow />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default TeacherDetailsMain;
